import { Chart } from 'chart.js';
import { UI_FONT } from './theme';

// Chart.js draws on canvas, so it can't inherit CSS fonts; point it at the
// same UI face the rest of the dashboard uses.
Chart.defaults.font.family = UI_FONT;
Chart.defaults.font.size = 12;
